import { createAction, props } from '@ngrx/store';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { CommonCieModel } from 'src/app/model/common/cie';

enum CommnCieActionLabels {
  SET_RESULT = 'COMMON_CIE_SET_RESULT',
  SET_ALL_DEFAULT = 'COMMON_CIE_SET_ALL_DEFAULT',
}

export const commonCieActions = {
  setResultAction: createAction(
    CommnCieActionLabels.SET_RESULT,
    props<VonPageResponseModel<CommonCieModel>>()
  ),
  setAllDefaultAction: createAction(
    CommnCieActionLabels.SET_ALL_DEFAULT,
    props<any>()
  ),
};
